import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PasswordInput from './PasswordInput';
import Brand from './Brand';
import BrandRoutes from './BrandRoutes';

export function AuthShell({ title, description, children }) {
  const headingRef = useRef(null);
  useEffect(() => { headingRef.current?.focus({ preventScroll: true }); }, [title]);
  return <main className="rf-auth">
    <section className="rf-auth-identity" aria-label="RotaFlex — gestão de transporte">
      <div className="rf-auth-identity-inner">
        <div className="rf-auth-brand"><Brand large /><h1 className="rf-visually-hidden">RotaFlex</h1></div>
        <div className="rf-auth-story">
          <p className="rf-auth-headline">Planeje as vans.<br />Acompanhe a operação.</p>
          <p className="rf-auth-intro">Distribua os passageiros e envie os trajetos aos motoristas.</p>
          <BrandRoutes />
        </div>
        <p className="rf-auth-identity-caption">Planejamento, passageiros e frota em uma operação.</p>
      </div>
    </section>
    <section className="rf-auth-access" aria-labelledby="rf-auth-heading">
      <div className="rf-auth-content fade-in">
        <h2 id="rf-auth-heading" ref={headingRef} tabIndex={-1} className="rf-auth-title">{title}</h2>
        <p className="rf-auth-description">{description || 'Use o e-mail cadastrado na sua transportadora.'}</p>
        <div className="rf-auth-form">{children}</div>
        <p className="rf-auth-caption">Precisa de acesso? Fale com o administrador da sua transportadora.</p>
      </div>
    </section>
  </main>;
}
AuthShell.propTypes = { title: PropTypes.string.isRequired, description: PropTypes.string, children: PropTypes.node };

export function AuthStatus({ error, message }) {
  if (!error && !message) return null;
  return <p role={error ? 'alert' : 'status'} style={{ color: error ? 'var(--danger)' : 'var(--text)', fontSize: '1rem', lineHeight: 1.6, border: `1px solid ${error ? 'var(--danger)' : 'var(--border)'}`, padding: '10px 12px', background: 'var(--s2)', borderRadius: 6 }}>
    {error || message}
  </p>;
}
AuthStatus.propTypes = { error: PropTypes.string, message: PropTypes.string };

export function NewPasswordFields({ password, confirmation, onPassword, onConfirmation, disabled }) {
  return <>
    <PasswordInput label="Nova senha" autoComplete="new-password" required minLength={8}
      value={password} onChange={e => onPassword(e.target.value)} disabled={disabled}
      hint="Use pelo menos 8 caracteres e evite senhas que você já usa em outros serviços." />
    <PasswordInput label="Confirmar nova senha" autoComplete="new-password" required minLength={8}
      value={confirmation} onChange={e => onConfirmation(e.target.value)} disabled={disabled} />
  </>;
}
NewPasswordFields.propTypes = {
  password: PropTypes.string.isRequired, confirmation: PropTypes.string.isRequired,
  onPassword: PropTypes.func.isRequired, onConfirmation: PropTypes.func.isRequired, disabled: PropTypes.bool,
};
